// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qa-9";
export var arrowButtonContainer = "_qa-5";
export var arrowButtonIcon = "_qa-6";
export var carouselArrowButton = "_qa-2";
export var carouselElementContainer = "_qa-1";
export var currentSlide = "_qa-8";
export var left = "_qa-3";
export var otherSlide = "_qa-a";
export var productCarouselContainer = "_qa-0";
export var right = "_qa-4";
export var sliderOverflow = "_qa-7";